module.exports = __webpack_public_path__ + "img/value_icon_four.1103609f.png";